export default "__VITE_ASSET__BYFVglYB__"